import { OrderModel } from "@app/interfaces/order";
import React from "react";
import ListImages from "../components/ListImages";

interface OrderInfoProps {
  record: OrderModel;
}

const OrderConfirmedByCustomerImages: React.FC<OrderInfoProps> = ({ record }) => {
  
  return (
    <ListImages
      record={record}
      assetType="confirmed"
      description="Hình ảnh sản phẩm được xác nhận bởi khách hàng (nếu có)"
    />
  )
}

export default OrderConfirmedByCustomerImages;